import { RangeSlider as AntdRangeSlider } from "@empglabs/backoffice-ui-kit"

const RangeSlider = props => {
  return <AntdRangeSlider {...props} />
}

export default RangeSlider
